import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-009e7910"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("nav", {
  class: "footer__legal",
  "aria-label": "Rechtliches"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "/impressum" }, "Impressum"),
  /*#__PURE__*/_createElementVNode("a", { href: "/datenschutz" }, "Datenschutz")
], -1))
const _hoisted_4 = { class: "footer__meta" }
const _hoisted_5 = {
  class: "footer__social",
  "aria-label": "Kontaktlinks"
}
const _hoisted_6 = {
  class: "footer__icon-link",
  href: "/vecura",
  "aria-label": "Vecura"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]

import { computed } from "vue";
import ContactChannelIcon from "@/components/icons/ContactChannelIcon.vue";
import { profile } from "@/data/profile";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteFooter',
  setup(__props) {

const emailHref = computed(() => `mailto:${profile.email}`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createVNode(ContactChannelIcon, {
              class: "footer__channel-icon",
              type: "vecura"
            })
          ]),
          _createElementVNode("a", {
            class: "footer__icon-link",
            href: _unref(profile).linkedinUrl,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": "LinkedIn"
          }, [
            _createVNode(ContactChannelIcon, {
              class: "footer__channel-icon",
              type: "linkedin"
            })
          ], 8, _hoisted_7),
          _createElementVNode("a", {
            class: "footer__icon-link",
            href: emailHref.value,
            "aria-label": "E-Mail"
          }, [
            _createVNode(ContactChannelIcon, {
              class: "footer__channel-icon",
              type: "mail"
            })
          ], 8, _hoisted_8)
        ])
      ])
    ])
  ]))
}
}

})